var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.40426,
    transform: "matrix(-1 0 0 1 12.2127 8.40419)",
    stroke: "#717171",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25531 16.8594C6.25531 16.1271 6.71561 15.474 7.40517 15.2277V15.2277C10.5141 14.1174 13.9114 14.1174 17.0203 15.2277V15.2277C17.7099 15.474 18.1702 16.1271 18.1702 16.8594V17.9789C18.1702 18.9895 17.2751 19.7658 16.2747 19.6229L15.9412 19.5753C13.4681 19.222 10.9574 19.222 8.48436 19.5753L8.15081 19.6229C7.15038 19.7658 6.25531 18.9895 6.25531 17.9789V16.8594Z",
    stroke: "#717171",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3192 11.9027C18.7964 11.9027 19.9939 10.7051 19.9939 9.2279C19.9939 7.75067 18.7964 6.55313 17.3192 6.55313",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.005L20.5107 18.0424C21.2967 18.1547 22 17.5448 22 16.7507V15.8711C22 15.2957 21.6383 14.7825 21.0965 14.589C20.5561 14.396 20.0045 14.2457 19.4468 14.1381",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68085 11.9027C5.20361 11.9027 4.00607 10.7051 4.00607 9.2279C4.00607 7.75067 5.20361 6.55313 6.68085 6.55313",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7514 18.005L3.48932 18.0424C2.70327 18.1547 2 17.5448 2 16.7507V15.8711C2 15.2957 2.36167 14.7825 2.90347 14.589C3.44392 14.396 3.99546 14.2457 4.55319 14.1381",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users.5071c086fc1a4aa66f8f9e5b430f56ed.svg";